const triggerConfetti = (button) => {
  if (typeof confetti === 'function') {
    const rect = button.getBoundingClientRect();
    const x = (rect.left + rect.width / 2) / window.innerWidth;
    const y = rect.top / window.innerHeight;

    confetti({
      particleCount: 150,
      spread: 60,
      origin: { x: x, y: y },
      colors: ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff', '#ffa500']
    });
  }
}


document.addEventListener('DOMContentLoaded', () => {
  let loading = false
  let queryZero = true
  let flkty


  if (!customElements.get('free-gift-progress')) {
    customElements.define('free-gift-progress', class FreeGiftProgress extends HTMLElement {
      constructor() {
        super()
        this.progressSettings = JSON.parse(this.querySelector('#free-gift-tier-amount').innerHTML)

        this.cartTotalPrice = this.progressSettings.cartTotalPrice + this.progressSettings.thresholdAmount

        this.cartItems = JSON.parse(this.querySelector('#cart-json').innerHTML)

        const rate = Number(window.Shopify.currency.rate)
        this.querySelectorAll('.money-amount').forEach(item => {
          item.innerHTML = `${this.progressSettings.currency}${Number(item.getAttribute('data-amount') * rate / 100).toFixed(2)}`
        })

        // for (const item of this.cartItems.items) {
        //   if (this.progressSettings.orderProtectionId == item.product_id) {
        //     this.cartTotalPrice -= Number(item.price)
        //     break
        //   }
        // }

        if (this.querySelector('#free-gift-multiple-bar')) {
          this.onUpdateMultipleBar()
        } else {
          this.onUpdateOneBar()
        }
      }

      progressSettings = {}
      cartItems = {}
      cartTotalPrice = 0

      onUpdateMultipleBar() {
        const rate = Number(window.Shopify.currency.rate)
        const currency = this.progressSettings.currency

        let oneText = ''
        let oneWidth = ''
        if (this.cartTotalPrice < this.progressSettings.tierOneAmount * rate) {
          const oneAmount = this.progressSettings.tierOneAmount * rate

          if (this.querySelector('[for="tier-one-currency"]'))
            this.querySelector('[for="tier-one-currency"]').innerHTML = currency + (oneAmount / 100).toFixed(2)

          oneText = this.progressSettings.tierOneText.replace('$money', 'SPEND ' + currency + ((this.progressSettings.tierOneAmount * rate - this.cartTotalPrice) / 100).toFixed(2))
          oneWidth = this.cartTotalPrice / (this.progressSettings.tierOneAmount * rate) * 100
        } else {
          oneText = this.progressSettings.tierOneFullfilText
          oneWidth = 100
        }
        if (this.querySelector('#tier-one-bar'))
          this.querySelector('#tier-one-bar').style.width = `${oneWidth}%`

        if (this.querySelector('#tier-one-fullfil-text') && oneWidth === 100) {
          this.querySelector('#tier-one-fullfil-text').innerHTML = oneText
        } else if (this.querySelector('#tier-one-text')) {
          this.querySelector('#tier-one-text').innerHTML = oneText
        }

        let twoText = ''
        let twoWidth = ''
        if (this.cartTotalPrice < this.progressSettings.tierTwoAmount * rate) {
          const twoAmount = this.progressSettings.tierTwoAmount * rate

          if (this.querySelector('[for="tier-two-currency"]'))
            this.querySelector('[for="tier-two-currency"]').innerHTML = currency + (twoAmount / 100).toFixed(2)

          twoText = this.progressSettings.tierTwoText.replace('$money', currency + ((twoAmount - this.cartTotalPrice) / 100).toFixed(2))
          twoWidth = this.cartTotalPrice / (this.progressSettings.tierTwoAmount * rate) * 100
        } else {
          twoText = this.progressSettings.tierTwoFullfilText
          twoWidth = 100
        }

        if (this.querySelector('#tier-two-bar'))
          this.querySelector('#tier-two-bar').style.width = `${twoWidth}%`

        if (this.querySelector('#tier-two-fullfil-text') && twoWidth === 100) {
          this.querySelector('#tier-two-fullfil-text').innerHTML = twoText
        } else if (this.querySelector('#tier-two-text')) {
          this.querySelector('#tier-two-text').innerHTML = twoText
        }

        let threeText = ''
        let threeWidth = ''
        if (this.cartTotalPrice < this.progressSettings.tierThreeAmount * rate) {
          const threeAmount = this.progressSettings.tierThreeAmount * rate

          if (this.querySelector('[for="tier-three-currency"]'))
            this.querySelector('[for="tier-three-currency"]').innerHTML = currency + (threeAmount / 100).toFixed(2)

          threeText = this.progressSettings.tierThreeText.replace('$money', currency + ((threeAmount - this.cartTotalPrice) / 100).toFixed(2))
          threeWidth = this.cartTotalPrice / (this.progressSettings.tierThreeAmount * rate) * 100
        } else {
          threeText = this.progressSettings.tierThreeFullfilText
          threeWidth = 100
        }
        if (this.querySelector('#tier-three-bar'))
          this.querySelector('#tier-three-bar').style.width = `${threeWidth}%`

        if (this.querySelector('#tier-three-fullfil-text') && threeWidth === 100) {
          this.querySelector('#tier-three-fullfil-text').innerHTML = threeText
        } else if (this.querySelector('#tier-three-text')) {
          this.querySelector('#tier-three-text').innerHTML = threeText
        }
      }

      isFirstInCart() {
        // if (this.progressSettings.autoRemoveFirst) {
        //   return true
        // }
        //
        const firstProduct = document.querySelectorAll('free-gift-product')[0]
        if (firstProduct) {
          let freeProductData = JSON.parse(firstProduct.querySelector('#free-products').innerHTML)

          for (let i = 0; i < this.cartItems.items.length; i++) {
            const item = this.cartItems.items[i]
            for (const product of freeProductData) {
              for (const variant of product.variants)
                if (item.variant_id === variant.id && item.final_line_price === 0) {
                  return true
                }
            }
          }
        }

        return false
      }

      onUpdateOneBar() {
        let text = ''
        const rate = Number(window.Shopify.currency.rate)
        const currency = this.progressSettings.currency
        let maxAmount = this.progressSettings.showTierFour ?
          this.progressSettings.tierFourAmount
          : this.progressSettings.tierThreeAmount

        if (maxAmount === 0) {
          maxAmount = this.progressSettings.tierOneAmount
        }

        let width = this.cartTotalPrice / (maxAmount * rate) * 100

        const oneLeft = (this.progressSettings.tierOneAmount / maxAmount) * 100
        const twoLeft = (this.progressSettings.tierTwoAmount / maxAmount) * 100
        const threeLeft = (this.progressSettings.tierThreeAmount / maxAmount) * 100
        // if (this.querySelector('#one-bar-tier-one-title .money'))
        //   this.querySelector('#one-bar-tier-one-title .money').innerHTML = `${currency}${Number(this.progressSettings.tierOneAmount * rate / 100).toFixed(2)}`
        // if (this.querySelector('#one-bar-tier-two-title .money'))
        //   this.querySelector('#one-bar-tier-two-title .money').innerHTML = `${currency}${Number(this.progressSettings.tierTwoAmount * rate / 100).toFixed(2)}`
        // if (this.querySelector('#one-bar-tier-three-title .money'))
        //   this.querySelector('#one-bar-tier-three-title .money').innerHTML = `${currency}${Number(this.progressSettings.tierThreeAmount * rate / 100).toFixed(2)}`
        // if (this.querySelector('#one-bar-tier-four-title .money'))
        //   this.querySelector('#one-bar-tier-four-title .money').innerHTML = `${currency}${Number(this.progressSettings.tierFourAmount * rate / 100).toFixed(2)}`
        //

        if (this.querySelector('[data-tier="one"]'))
          this.querySelector('[data-tier="one"]').style.left = `${oneLeft}%`

        if (this.querySelector('#one-bar-tier-one-title')) {
          // 如果free shipping是0，左对其
          if (this.progressSettings.tierOneAmount === 0) {
            this.querySelector('#one-bar-tier-one-title').style.left = `${0}%`
            this.querySelector('#one-bar-tier-one-title').style.transform = `none`
            // 如果free gift是0，左对齐
          } else if (this.progressSettings.tierThreeAmount === 0) {
            this.querySelector('#one-bar-tier-one-title').style.right = `${0}%`
            this.querySelector('#one-bar-tier-one-title').style.left = `unset`
            this.querySelector('#one-bar-tier-one-title').style.transform = `none`
          } else {
            this.querySelector('#one-bar-tier-one-title').style.left = `unset`
            this.querySelector('#one-bar-tier-one-title').style.position = `unset`
            this.querySelector('#one-bar-tier-one-title').style.transform = `none`

            if (this.querySelector('#one-bar-tier-three-title')) {
              this.querySelector('#one-bar-tier-three-title').style.left = `unset`
              this.querySelector('#one-bar-tier-three-title').style.position = `unset`
              this.querySelector('#one-bar-tier-three-title').style.transform = `none`
            }

            if (this.querySelector('#one-bar-tier-four-title')) {
              this.querySelector('#one-bar-tier-four-title').style.left = `unset`
              this.querySelector('#one-bar-tier-four-title').style.position = `unset`
              this.querySelector('#one-bar-tier-four-title').style.transform = `none`
            }

            this.querySelector('.one-bar-text-wrapper').style.display = "flex"
            // this.querySelector('.one-bar-text-wrapper').style.justifyContent = "flex-end"
            this.querySelector('.one-bar-text-wrapper').style.gap = "10px"
          }
        }

        if (this.progressSettings.showTierFour) {
          if (this.querySelector('[data-tier="two"]'))
            this.querySelector('[data-tier="two"]').style.left = `${twoLeft}%`
          if (this.querySelector('#one-bar-tier-two-title'))
            this.querySelector('#one-bar-tier-two-title').style.left = `${50}%`
          if (this.querySelector('[data-tier="three"]'))
            this.querySelector('[data-tier="three"]').style.left = `${threeLeft}%`
          if (this.querySelector('#one-bar-tier-three-title'))
            this.querySelector('#one-bar-tier-three-title').style.left = `${50}%`

          if (this.querySelector('#one-bar-tier-four-title'))
            this.querySelector('#one-bar-tier-four-title').style.right = `0`
          if (this.querySelector('#one-bar-tier-four-title'))
            this.querySelector('#one-bar-tier-four-title').style.transform = `translateX(0)`
        } else {
          if (this.querySelector('[data-tier="three"]'))
            this.querySelector('[data-tier="three"]').style.display = 'none'
          if (this.querySelector('#one-bar-tier-three-title')) {
            this.querySelector('#one-bar-tier-three-title').style.right = `${0}%`
            this.querySelector('#one-bar-tier-three-title').style.transform = `translateX(0)`
          }
        }

        const baseLeft = this.querySelector('.progress-bar-outer').getClientRects()[0].left

        if (this.cartTotalPrice < this.progressSettings.tierOneAmount * rate && this.querySelector('#one-bar-tier-one-title')) {
          const tierOneLength = this.querySelector('#one-bar-tier-one-title').getClientRects()[0].right - 5

          const tierOnePercent = (tierOneLength - baseLeft) / this.querySelector('.progress-bar-outer').getClientRects()[0].width

          width = this.cartTotalPrice / (this.progressSettings.tierOneAmount * rate) * tierOnePercent * 100

          text = this.progressSettings.tierOneText.replace('$money', currency + (((this.progressSettings.tierOneAmount * rate) - this.cartTotalPrice) / 100).toFixed(2))
        } else if (this.cartTotalPrice < this.progressSettings.tierThreeAmount * rate || !this.progressSettings.showTierFour) {

          if (this.querySelector('#one-bar-tier-one-title'))
            this.querySelector('#one-bar-tier-one-title').classList.add('fullfil')
          if (this.querySelector('[data-tier="one"]'))
            this.querySelector('[data-tier="one"]').style.background = `white`
          if (this.querySelector('[data-tier="two"]'))
            this.querySelector('[data-tier="two"]').style.background = `white`
          if (this.querySelector('#one-bar-tier-two-title'))
            this.querySelector('#one-bar-tier-two-title')?.classList.add('fullfil')

          // 不显示第二个free gift
          if (this.cartTotalPrice < this.progressSettings.tierThreeAmount * rate && this.querySelector('#one-bar-tier-three-title')) {
            const tierThreeLength = this.querySelector('#one-bar-tier-three-title').getClientRects()[0].right

            const tierThreePercent = (tierThreeLength - baseLeft) / this.querySelector('.progress-bar-outer').getClientRects()[0].width

            width = this.cartTotalPrice / (this.progressSettings.tierThreeAmount * rate) * 100

            text = this.progressSettings.tierThreeText.replace('$money', currency + (((this.progressSettings.tierThreeAmount * rate) - this.cartTotalPrice) / 100).toFixed(2))
          } else {
            text = this.progressSettings.tierThreeFullfilText.replace(this.isFirstInCart() ? 'Add to bag below.' : '', '')
            this.querySelector('#one-bar-tier-three-title')?.classList.add('fullfil')
          }
        } else if (this.cartTotalPrice < this.progressSettings.tierFourAmount * rate && this.progressSettings.showTierFour) {
          if (this.querySelector('#one-bar-tier-one-title'))
            this.querySelector('#one-bar-tier-one-title').classList.add('fullfil')
          if (this.querySelector('[data-tier="one"]'))
            this.querySelector('[data-tier="one"]').style.background = `white`
          if (this.querySelector('[data-tier="two"]'))
            this.querySelector('[data-tier="two"]').style.background = `white`
          if (this.querySelector('#one-bar-tier-two-title'))
            this.querySelector('#one-bar-tier-two-title')?.classList.add('fullfil')
          if (this.querySelector('[data-tier="three"]'))
            this.querySelector('[data-tier="three"]').style.background = `white`
          if (this.querySelector('#one-bar-tier-three-title'))
            this.querySelector('#one-bar-tier-three-title')?.classList.add('fullfil')
          text = this.progressSettings.tierFourText.replace('$money', currency + (((this.progressSettings.tierFourAmount * rate) - this.cartTotalPrice) / 100).toFixed(2))
        } else {
          text = !this.isFirstInCart() ? this.progressSettings.tierThreeFullfilText : this.progressSettings.tierFourFullfilText
          if (this.querySelector('#one-bar-tier-one-title'))
            this.querySelector('#one-bar-tier-one-title').classList.add('fullfil')
          if (this.querySelector('[data-tier="one"]')) {
            this.querySelector('[data-tier="one"]').style.background = `white`
          }
          if (this.querySelector('[data-tier="two"]')) {
            this.querySelector('[data-tier="two"]').style.background = `white`
            this.querySelector('#one-bar-tier-two-title').classList.add('fullfil')
          }
          if (this.querySelector('[data-tier="three"]')) {
            this.querySelector('[data-tier="three"]').style.background = `white`
            this.querySelector('#one-bar-tier-three-title')?.classList.add('fullfil')
          }
          this.querySelector('#one-bar-tier-four-title')?.classList.add('fullfil')

          width = 100
        }

        if (document.querySelector('#one-bar-text')) {
          document.querySelector('#one-bar-text').innerHTML = text;
          this.querySelector('#one-bar-progress').style.width = `${width}%`;
        }
      }
    })
  }


  if (!customElements.get('free-gift-product')) {
    customElements.define('free-gift-product', class FreeGiftProduct extends HTMLElement {
      constructor() {
        super()
        this.rate = Number(window.Shopify.currency.rate)

        this.cartItems = JSON.parse(this.querySelector('#cart-json').innerHTML)

        this.cartTotalPrice = (this.cartItems.total_price) + Number(this.getAttribute('data-threshold-amount'))

        this.freeProductData = JSON.parse(this.querySelector('#free-products').innerHTML)
        this.freeProductAmount = Number(this.getAttribute('data-free-number')) * this.rate

        const json = JSON.parse(this.querySelector('#free-product-json').innerHTML)
        this.freeGiftJson = json

        // for (const item of this.cartItems.items) {
        //   if (this.freeGiftJson.orderProtectionId == item.product_id) {
        //     this.cartTotalPrice -= Number(item.price)
        //     break
        //   }
        // }


        if (this.freeGiftJson.show) {
          this.setText(json)

          this.querySelectorAll('select').forEach(item => item.addEventListener('change', event => this.onVarBtnSelect(event)))

          if (this.freeGiftJson.addToType === 'add-btn') {
            this.querySelectorAll('.free-gift-product-buy').forEach(item => item.addEventListener('click', (event) => this.onAddBtnClick(event)))
          }


          this.onCartUpdate()
        } else {
          document.querySelector('cart-drawer').classList.remove('is-loading')
        }
      }

      flkty = null
      rate = 0
      freeGiftJson = {}
      cartTotalPrice = 0
      cartItems = {}
      freeProductIndex = 0
      freeVariantIndex = 0
      variantToBeRemove = {}
      freeProductAmount = 0
      freeProductData = []
      hasFreeProductInCart = false

      setText(data) {
        const freeAmount = Number(data.freeAmount * this.rate)
        const currency = this.freeGiftJson.currency

        if (this.querySelector('#free-product-title')) {
          this.querySelector('#free-product-title').innerHTML = data.freeProductTitle.replace('$money', currency + (freeAmount / 100).toFixed(2))
        }

        if (freeAmount > (this.cartItems.total_price)) {
          const unlockAmount = (freeAmount - (this.cartItems.total_price)) / 100
          if (this.querySelector('#free-product-subtitle'))
            this.querySelector('#free-product-subtitle').innerHTML = data.freeProductSubtitle.replace('$money', currency + unlockAmount.toFixed(2))

          // if (this.freeGiftJson.addToType === 'add-btn')
          //   this.querySelector('#free-product-btn span').innerHTML = data.freeUnlockText.replace('$money', currency + unlockAmount.toFixed(2))
        } else if (this.freeGiftJson.addToType === 'add-btn') {
          // this.querySelector('#free-product-btn span').innerHTML = data.freeBtnFullfilText
        }
      }

      onVarBtnSelect(event) {
        if (loading) {
          return
        }

        if (this.cartTotalPrice >= this.freeProductAmount) {
          this.querySelectorAll('.free-gift-product-buy').forEach(item => item.classList.remove('disabled'));
        }
      }

      onCartUpdate() {
        let cartTotalPrice = this.cartTotalPrice

        if (!this.freeGiftJson.show) {
          return
        }

        const index = Number(this.getAttribute('data-index'))
        let isFirstInCart = false
        let isSecondInCart = false

        const secondProduct = document.querySelectorAll('free-gift-product')[1]

        if (!this.freeProductData.length) {
          return
        }

        // let rate = Number(window.Shopify.currency.rate)
        // if (index === 0 && this.cartItems.total_price >= this.freeGiftJson.secondGiftAmount * rate
        //   && secondProduct) {
        //   return
        // }

        let titleText = ''

        const rate = Number(window.Shopify.currency.rate)
        const currency = this.freeGiftJson.currency

        this.querySelectorAll('.free-gift-product-wrpper-inner').forEach((item) => {
          this.freeProductData.forEach((subItem, subIndex) => {
            const titleTemplate = index === 0 ? this.freeGiftJson.tierThreeTitle : this.freeGiftJson.tierFourTitle
            const freeAmount = index === 0 ? this.freeGiftJson.freeAmount : this.freeGiftJson.secondGiftAmount

            if (this.cartTotalPrice < (freeAmount * rate)) {
              item.querySelector('.free-gift-product-wrapper-product-info .product-desc').innerHTML =
                titleTemplate
                  .replace('$price', `${currency}${Number((subItem.variants[0].price * rate / 100).toFixed(2))}`)
                  .replace('$moneyMore', `${currency}${Number(((freeAmount * rate - this.cartTotalPrice) / 100).toFixed(2))}`)
                  .replace('$subtotal', `${currency}${Number((this.freeProductAmount / 100).toFixed(2))}`)
                  .replace('$title', subItem.title)
            } else {
              item.querySelector('.free-gift-product-wrapper-product-info .product-desc').innerHTML =
                index === 0 ? this.freeGiftJson.tierThreeFullfilText : this.freeGiftJson.tierFourFullfilText
            }
          })
        })

        if (index === 0 && secondProduct) {
          let freeProductData = JSON.parse(secondProduct.querySelector('#free-products').innerHTML)

          for (let i = 0; i < this.cartItems.items.length; i++) {
            const item = this.cartItems.items[i]
            for (const product of freeProductData) {
              for (const variant of product.variants) {
                if (item.variant_id === variant.id) {
                  isSecondInCart = true;
                  break
                }
              }
            }
          }
        }

        this.variantToBeRemove = {}
        for (let i = 0; i < this.cartItems.items.length; i++) {
          const item = this.cartItems.items[i]
          this.freeProductIndex = 0
          for (const product of this.freeProductData) {
            for (const variant of product.variants) {
              if (item.variant_id === variant.id) {
                this.hasFreeProductInCart = true;
                cartTotalPrice -= item.final_line_price
                this.variantToBeRemove[item.variant_id] = 0
                break
              }
              this.freeVariantIndex += 1
            }

            if (this.hasFreeProductInCart) {
              break
            } else {
              this.freeProductIndex += 1
            }
          }
        }

        const firstProduct = document.querySelectorAll('free-gift-product')[0]
        if (index === 1 && firstProduct) {
          // FIXED: Changed from #free-product-variants to #free-products to get full product data
          let freeProducts = JSON.parse(firstProduct.querySelector('#free-products').innerHTML)
          let freeProductData = freeProducts.flatMap(p => p.variants) // Extract all variants
          const freeProductJson = JSON.parse(firstProduct.querySelector('#free-product-json').innerHTML)

          if (!freeProductJson.show) {
            isFirstInCart = true
          } else {
            for (let i = 0; i < this.cartItems.items.length; i++) {
              const item = this.cartItems.items[i]
              for (const variant of freeProductData) {
                if (item.variant_id === variant.id && (item.final_line_price === 0 || queryZero)) {
                  isFirstInCart = true;
                  break
                }
              }
            }
          }

          //when first product in cart, show the progress bar for second product
          //add based on customer feedback

          if (isFirstInCart && document.querySelectorAll('.tier-four')) {
            const tierFourElements = document.querySelectorAll('.tier-four');

            tierFourElements.forEach(function (element) {
              element.style.display = "flex";
            });
          }
        }

        document.querySelector('cart-drawer')?.classList.remove('is-loading');

        // 如果购物车金额达到了free gift的金额
        if (cartTotalPrice >= this.freeProductAmount) {
          // 如果购物车里面没有
          if (!this.hasFreeProductInCart) {
            // 如果只有一个variants
            if (!this.querySelector('select') && this.freeGiftJson.addType === 'auto') {
              loading = true
              setTimeout(() => {
                document.querySelector('cart-drawer').classList.add('is-loading');
              }, 20);
              CartJS.addItems(this.freeProductData.map(item => ({
                id: item.variants[0].id,
                quantity: 1
              })))
            } else {
              this.style.display = 'block'
            }
          } else {
            // CartJS.updateItemQuantitiesById(this.variantToBeRemove)
            // setTimeout(() => {
            //   document.querySelector('cart-drawer').classList.add('is-loading');
            // }, 20);
            // this.style.display = 'none'
          }
        } else if (this.hasFreeProductInCart && this.freeProductAmount > cartTotalPrice) {
          this.style.display = 'block'
          if (this.hasFreeProductInCart) {
            CartJS.updateItemQuantitiesById(this.variantToBeRemove)
            setTimeout(() => {
              document.querySelector('cart-drawer').classList.add('is-loading');
            }, 20);
          }
        } else {
          if (this.hasFreeProductInCart) {
            setTimeout(() => {
              document.querySelector('cart-drawer').classList.add('is-loading');
            }, 20);
            CartJS.updateItemQuantitiesById(this.variantToBeRemove)
          }
          if (index === 0) {
            this.style.display = 'block'
          } else if (index === 1 && isFirstInCart) {
            this.style.display = 'block'
          }
        }
      }

      onAddBtnClick(event) {
        if (event.target.closest('#free-product-btn').classList.contains('free-gift-loading') || event.target.closest('#free-product-btn').classList.contains('disabled')) {
          return
        }

        let id = ''
        if (this.freeGiftJson.variantType === 'select' && this.querySelector('select')) {
          id = this.querySelector('select').value
        } else if (this.querySelectorAll('.free-gift-varitant-btn').length) {
          this.querySelectorAll('.free-gift-varitant-btn').forEach(item => {
            if (item.classList.contains('selected')) {
              id = item.getAttribute('data-var-id')
            }
          })
        } else {
          id = event.target.closest('#free-product-btn').getAttribute('data-var-id')
        }

        event.target.closest('#free-product-btn').classList.add('free-gift-loading')

        loading = true
        if (id) {
          CartJS.addItem(id)
        } else {
          CartJS.addItem(event.target.getAttribute('data-var-id'))
        }
      }

      onVarBtnClick(event) {
        if (loading) {
          return
        }

        this.querySelectorAll('.free-gift-varitant-btn').forEach(item => {
          item.classList.remove('selected')
        })
        this.querySelector('.free-gift-product-buy')?.classList.remove('disabled')

        event.target.classList.add('selected')


        if (this.freeGiftJson.addToType !== 'add-btn') {
          loading = true
          CartJS.addItem(event.target.getAttribute('data-var-id'))
          event.target.closest('.free-gift-varitant-btn').classList.add('free-gift-loading')
        }
      }
    })
  }


  if (!customElements.get('additional-products')) {
    customElements.define('additional-products', class AdditionalProducts extends HTMLElement {
      constructor() {
        super()

        this.freeGiftJson = JSON.parse(this.querySelector('#additional-product-json').innerHTML)

        if (this.freeGiftJson.variantType === 'btn')
          this.querySelectorAll('.additional-variants-btn').forEach(item => item.addEventListener('click', (event) => this.onVarBtnClick(event)))
        else {
          this.querySelectorAll('.free-gift-select select').forEach(item => item.addEventListener('change', (event) => {
            this.onVarBtnSelect(event)
          }))
        }

        if (this.querySelector('.add-btn')) {
          this.querySelectorAll('.add-btn').forEach(item => item.addEventListener('click', event => {
            let id = ''
            if (event.target.classList.contains('add-btn')) {
              event.target.classList.add('free-gift-loading')
              id = event.target.getAttribute('data-var-id')
            } else {
              event.target.parentNode.classList.add('free-gift-loading')
              id = event.target.parentNode.getAttribute('data-var-id')
            }

            loading = true
            CartJS.addItem(id)
          }))
        }

        this.onCartUpdate()
        // if (document.querySelector('.main-carousel')) {
        document.querySelectorAll('.main-carousel').forEach(item => {
          flkty = new Flickity(item, {
            cellAlign: 'left',
            prevNextButtons: true,
            contain: true,
            pageDots: false
          });
          flkty.resize()

          setTimeout(() => {
            item.style.visibility = 'visible'
          }, 50)
        })

        // }
      }

      cartItems = {}
      freeGiftJson = {}

      onCartUpdate() {
        this.cartItems = JSON.parse(this.querySelector('#additional-cart-json').innerHTML)
        let count = 0
        this.querySelectorAll('.additional-product-card').forEach(card => {
          const id = Number(card.getAttribute('data-product-id'))
          if (!this.cartItems.items.find(item => item.product_id === id) && count < this.freeGiftJson.number) {
            card.style.display = 'flex'
            count += 1
          } else {
            card.style.display = 'none'
            card.parentNode.removeChild(card)
          }
        })
        if (count === 0) {
          this.style.display = 'none'
        }
      }

      onVarBtnSelect(event) {
        const id = event.target.value
        event.target.closest('div').classList.add('free-gift-loading')
        CartJS.addItem(id)
      }

      onVarBtnClick(event) {
        if (loading) {
          return
        }

        const id = event.target.getAttribute('data-var-id')
        // event.target.parentNode.parentNode.parentNode.parentNode.style.display = 'none'
        loading = true
        CartJS.addItem(id)
        event.target.closest('.additional-variants-btn').classList.add('free-gift-loading')
      }
    })
  }

  if (!customElements.get('upsell-item')) {
    customElements.define('upsell-item', class UpsellItem extends HTMLElement {
      constructor() {
        super()

        this.variantType = this.getAttribute('data-variant-type')
        this.cartItems = JSON.parse(this.querySelector('#cart-json').innerHTML)

        if (this.variantType === 'btn')
          this.querySelectorAll('.upsell-variants-btn').forEach(item => item.addEventListener('click', (event) => this.onVarBtnClick(event)))
        else
          this.querySelector('.free-gift-select select')?.addEventListener('change', (event) => this.onVarBtnSelect(event))


        this.querySelector('.add-btn')?.addEventListener('click', event => {
          let id = ''
          if (event.target.classList.contains('add-btn')) {
            event.target.classList.add('free-gift-loading')
            id = event.target.getAttribute('data-var-id')
          } else {
            event.target.parentNode.classList.add('free-gift-loading')
            id = event.target.parentNode.getAttribute('data-var-id')
          }

          loading = true
          CartJS.addItem(id)
        })

        this.querySelector('.upsell-item-close')?.addEventListener('click', () => {
          this.style.display = 'none'
        })

        this.onCartUpdate()
      }

      cartItems = {}
      addToType = ''
      variantType = ''

      onCartUpdate() {
        if (!this.cartItems.items.find(item => item.product_id === Number(this.getAttribute('data-product-id'))) && !localStorage.getItem(`upsell-hide-${this.getAttribute('data-product-id')}-${this.getAttribute('data-cart-id')}`)) {
          this.querySelector('.product-card').style.display = 'flex'
          this.style.display = 'block'
        } else {
          this.style.display = 'none'
          this.querySelector('.product-card').style.display = 'none'
        }
      }

      onVarBtnSelect(event) {
        const id = event.target.value
        event.target.closest('div').classList.add('free-gift-loading')
        CartJS.addItem(id)
      }

      onVarBtnClick(event) {
        if (loading) {
          return
        }

        const id = event.target.getAttribute('data-var-id')
        loading = true
        CartJS.addItem(id)
        event.target.closest('.upsell-variants-btn').classList.add('free-gift-loading')
      }
    })
  }

  let completeTimeout = null
  let noRefresh = false

  $(document).on('cart.requestComplete', (event, cart) => {
    if (completeTimeout || window.displayUpgrade) {
      return
    }
    if (window.noCartRefresh) {
      window.noCartRefresh = false
      noRefresh = true
    }

    completeTimeout = setTimeout(() => {
      let section_id = ''
      document.querySelectorAll('.shopify-section-group-header-group').forEach(item => {
        if (item.getAttribute('id').includes('cart-drawer')) {
          section_id = item.getAttribute('id').replace('shopify-section-', '')
        }
      })
      let pathname = location.pathname.split('/')[1]
      if (pathname && pathname !== 'products') {
        pathname = '/' + pathname
      } else {
        pathname = ''
      }

      fetch(`${pathname}/cart?section_id=${section_id}`)
        .then((response) => response.text())
        .then((response) => {
          // document.querySelector('#cart-drawer').innerHTML = response
          console.log(document.querySelector('#addToCart'))
          document.querySelector('#cart-drawer .drawer__inner').innerHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.drawer__inner').innerHTML
          document.querySelector('#cart-drawer').classList.remove('is-loading')
          document.querySelector('#addToCart')?.classList.remove('free-gift-loading')

          if (!document.querySelector('#cart-drawer').classList.contains('is-drawer-open')) {
            toggleCart()
          } else {
            document.querySelectorAll(['[data-animation="cart-items-fade"]']).forEach(item => {
              item.classList.toggle('is-animated')
            }, 50)
          }
          document.querySelector('checkout-btn')?.classList.remove('free-gift-loading')
          document.querySelector('#addToCart')?.classList.remove('free-gift-loading')
        })

      fetch(`${pathname}/cart.js`)
        .then((response) => response.json())
        .then((response) => {
          document.querySelectorAll('cart-counter')
            .forEach(item => {
              let count = response.item_count
              const protectionId = Number(item.getAttribute('data-order-protection-id'))

              for (const item of response.items) {
                if (item.product_id === protectionId) {
                  count--
                }
              }
              item.updateCount(count)
            })
        })
      completeTimeout = null
    }, 100)
  })
})
